import {LinearProgress} from 'components/UIKit';

type Props = {
    value: number
};

export const GlobalLoader: React.FC<Props> = ({value}: Props) => (
    <div className='tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-z-global-loader'>
        <LinearProgress value={value} />
    </div>
);
